import React from "react";

function SupportSkeleton() {
  return (
    <div className="bg-slate-100 h-full">
      <div className="container mx-auto py-12 px-4 md:px-0 animate-pulse">
        <div className="text-center mt-10">
          <div className="h-4 bg-slate-200 rounded w-24 mx-auto mb-2" />
          <div className="h-8 bg-slate-200 rounded w-2/3 mx-auto" />
        </div>

        <div className="mb-12 flex justify-center mt-10">
          <div className="h-10 bg-slate-200 rounded w-full max-w-md" />
        </div>

        <div className="grid md:gap-5 gap-2 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden border border-slate-200 p-10"
            >
              <div className="h-6 bg-slate-200 rounded w-1/2 mb-6" />
              <div className="space-y-4">
                {Array.from({ length: 3 }).map((_, i) => (
                  <div key={i} className="h-4 bg-slate-200 rounded" />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SupportSkeleton;